import actions from './user_actions'
import state from './user_state'
import getters from './user_getters'
import mutations from './user_mutations'
// import watchers from './user_watchers'

export default {
    name: 'user',
    getters,
    mutations,
    state,
    actions
    // watchers
}
